const PLP_URL_PATTERN = "^/[a-z]{2}-[a-z]{2}/l/.*";
export const config = {
  "experiment.manualPromoCode": {
    defaultValue: "noVariation",
    /** Variations: disabled / enabled */
    urlPatterns: ["^/[a-z]{2}-[a-z]{2}.*"],
    provider: "cloudbees"
  },
  "experiment.globalAA": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.homeAA": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/?$"
      /* Home page */
    ],
    provider: "cloudbees"
  },
  "experiment.landingAA": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
      /* Landing page */
    ],
    provider: "cloudbees"
  },
  "experiment.productAA": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.checkoutAA": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  /** Variations:
   * home
   * home-duplicated */
  "experiment.webHomeCMSPageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/?$"
      /* Home page - permanent AB test */
    ],
    provider: "cloudbees"
  },
  "experiment.goodDealsEventPageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/e/.*$"
    ],
    provider: "cloudbees"
  },
  "experiment.recyclingEventPageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/e/.*$"
    ],
    provider: "cloudbees"
  },
  "experiment.holidaysEventPageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/e/.*$"
    ],
    provider: "cloudbees"
  },
  "experiment.homeBuybackPageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/buyback/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.smartphonesUniversePageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.laptopsUniversePageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.tabletsUniversePageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.audioUniversePageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.gamingUniversePageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.appliancesUniversePageName": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.macbookPlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  "experiment.ipadPlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  "experiment.iphonePlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  "experiment.samsungPlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  "experiment.googlePixelPlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  "experiment.androidSmartphonesPlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  "experiment.windowsLaptopsPlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  "experiment.samsungGalaxyTabPlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  "experiment.appleWatchPlpPageName": {
    defaultValue: "noVariation",
    urlPatterns: [PLP_URL_PATTERN],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/wiki/spaces/SR/pages/5334073749/PRD+Gift+Cards+POC?focusedCommentId=5750030399
  "experiment.giftCards": {
    defaultValue: "noVariation",
    /** Variations:
     * withGiftCards
     * withoutGiftCards */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.enableScalapayIT": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages (in the footer) */
    ],
    provider: "cloudbees"
  },
  "experiment.reviewSellerAndFilters": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * showSeller */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/l/.*",
      "^/[a-z]{2}-[a-z]{2}/r/p/.*",
      "^/[a-z]{2}-[a-z]{2}/r/.*",
      "^/[a-z]{2}-[a-z]{2}/r/s/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.reviewAmount": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * tenReviews
     * sevenReviews */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.reviewsAiSummary": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * withoutAIReview
     * withAIReview
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.reviewsNewAITags": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * withoutAITags
     * withAITags
     * withHighlightedAITags
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/l/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.reviewsHelpRequestStatus": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * withoutHelpRequestStatus
     * withHelpRequestStatus
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/l/.*",
      "^/[a-z]{2}-[a-z]{2}/r/.*",
      "^/[a-z]{2}-[a-z]{2}/s/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.reviewsReviewerInformation": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/l/.*",
      "^/[a-z]{2}-[a-z]{2}/r/.*",
      "^/[a-z]{2}-[a-z]{2}/s/.*"
    ],
    /** Variations:
     * noVariation
     * withReviewerInformation
     * withoutReviewerInformation
     */
    provider: "cloudbees"
  },
  "experiment.sellerRatingPDP": {
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    /** Variations:
     * noVariation
     * withSellerRating
     * withoutSellerRating
     */
    provider: "cloudbees"
  },
  "experiment.reviewsRatingHeader": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * withReviewsRatingHeader
     * withoutReviewsRatingHeader
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.usModularPDP": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * enable
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.applePayOnThirdPartyBrowsers": {
    /** Variations:
     * enabled
     * disabled
     */
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.unifiedApplePayAdapter": {
    /** Variations:
     * enabled
     * disabled
     */
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.mpanOnApplePayRecurringPayments": {
    /** Variations:
     * enabled
     * disabled
     * noVariation
     */
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*",
      "^/[a-z]{2}-[a-z]{2}/insurance/update-payment-method/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.expressDeliveryBenefit": {
    /** Variations:
     * disabled
     * getItSooner
     * fastestOptionOnly
     */
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.checkoutCollectionPointOption": {
    /** Variations:
     * collectionPointEnabled
     * collectionPointDisabled
     */
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.serviceFeeGrid": {
    /** Variations:
     * newServiceFeeGrid
     * currentServiceFeeGrid
     */
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.countrySwitchRedirection": {
    /** Variations:
     * withRedirection
     * withoutRedirection */
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.deliveryDateAdjustment": {
    /** Variations:
     * withAdjustment
     * withoutAdjustment */
    defaultValue: "noVariation",
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.flashSales": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.flashSalesOnPDP": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.newOfferPageV3": {
    defaultValue: "noVariation",
    /** Variations:
     * withGraph
     * withoutGraph */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/buyback/.*"
      /* All Buyback Pages */
    ],
    provider: "cloudbees"
  },
  "experiment.resaleBankStep": {
    defaultValue: "noVariation",
    /** Variations:
     * withBankStep
     * withoutBankStep */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/buyback/.*"
      /* All Buyback Pages */
    ],
    provider: "cloudbees"
  },
  "experiment.resaleImeiStepV2": {
    defaultValue: "noVariation",
    /** Variations:
     * withMandatoryImei
     * withOptionalImei
     * withoutImei
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/buyback/.*"
      /* All Buyback Pages */
    ],
    provider: "cloudbees"
  },
  "experiment.saveTradeInInCart": {
    defaultValue: "noVariation",
    /** Variations:
     * with
     * without */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/buyback-funnel/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.regularBuybackNpm": {
    defaultValue: "noVariation",
    /** Variations:
     * withNpm
     * withOutNpm */
    urlPatterns: [
      "^.*"
      /* All pages and applications */
    ],
    provider: "cloudbees"
  },
  "experiment.buybackAtcButtons": {
    defaultValue: "noVariation",
    /** Variations:
     * withNewButtons
     * withOldButtons */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.promoCodeInCart": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.hidePlpBanner": {
    defaultValue: "noVariation",
    /** Variations:
     * with
     * without */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
      /* PLP page */
    ],
    provider: "cloudbees"
  },
  "experiment.isBatteryEducationEnabled": {
    defaultValue: "noVariation",
    /** Variations:
     * with
     * without */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
      /* PLP page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppJapanBlackFridaySpecial": {
    defaultValue: "noVariation",
    /** Variations:
     * withBlackFridaySpecial
     * withoutBlackFridaySpecial */
    urlPatterns: [
      "^/ja-jp/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppJapanBatteryPickerUpdated": {
    defaultValue: "noVariation",
    /** Variations:
     * withBatteryPickerUpdated
     * withoutBatteryPickerUpdated */
    urlPatterns: [
      "^/ja-jp/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppJapanPremiumDefinitionUpdated": {
    defaultValue: "noVariation",
    /** Variations:
     * withPremiumDefinitionUpdated
     * withoutPremiumDefinitionUpdated */
    urlPatterns: [
      "^/ja-jp/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.tradeInAU": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/en-au/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.tradeInSwapJapan": {
    defaultValue: "noVariation",
    /** Variations:
     * withBelongSwap
     * withoutBelongSwap */
    urlPatterns: [
      "^/ja-jp/.*"
      /* All JP pages */
    ],
    provider: "cloudbees"
  },
  "experiment.navBarUpdateJp": {
    defaultValue: "noVariation",
    /** Variations:
     * withNavUpdate
     * withoutNavUpdate */
    urlPatterns: [
      "^/ja-jp/.*"
      /* All JP pages */
    ],
    provider: "cloudbees"
  },
  "experiment.ppUpgradeForLessV2": {
    defaultValue: "noVariation",
    /** Variations:
     * withUpgrade
     * withoutUpgrade */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.cmsPromotionalBanner": {
    defaultValue: "noVariation",
    /** Variations:
     * controlText
     * variantText
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages (above Header) */
    ],
    provider: "cloudbees"
  },
  "experiment.ppTelcoCalculator": {
    defaultValue: "noVariation",
    /** Variations:
     * withCalculator
     * withouCalculator */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/browse/USB2CS-903
  "experiment.ppTelcoComparison": {
    defaultValue: "noVariation",
    /** Variations:
     * withPicker
     * noVariation */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/browse/USB2CS-916
  "experiment.ppTelcoPartnerPriority": {
    defaultValue: "noVariation",
    /** Variations:
     * withVisiblePriority
     * withUSMobilePriority
     * withNoblePriority
     * withoutPartnerPopups
     * noVariation */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppNobleNewOffer": {
    defaultValue: "noVariation",
    /** Variations:
     * withNewOffer
     * noVariation */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/browse/CHIPS-980
  "experiment.ppFreenetMobilePlans": {
    defaultValue: "noVariation",
    /** Variations:
     * withFreenetMobilePlans
     * withoutFreenetMobilePlans
     * noVariation */
    urlPatterns: [
      "^/de-de/p/.*"
      /* DE Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppDynamicReviewsInCarousel": {
    defaultValue: "noVariation",
    /** Variations:
     * withDynamicReviews
     * withStaticReviews */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppBatteryConfidence": {
    defaultValue: "noVariation",
    /** Variations:
     * default
     * withText
     * withNumbers */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/browse/PPI-7953
  "experiment.ppOptimisedFakeSoldOut": {
    defaultValue: "noVariation",
    /** Variations:
     * withOptimisedFakeSoldOut
     * withoutOptimisedFakeSoldOut */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppFakeInStock": {
    defaultValue: "noVariation",
    /** Variations:
     * withFakeInStock
     * withoutFakeInStock */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppProfessionallyCleanedSticker": {
    defaultValue: "noVariation",
    /** Variations:
     * withProfessionallyCleaned
     * withoutProfessionallyCleaned */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppCondensedFunnel": {
    defaultValue: "noVariation",
    /** Variations:
     * withCondensedFunnel
     * withoutCondensedFunnel */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.enableEsUsContent": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.enableEsUsLocaleSelector": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * selectorEnabled
     * selectorDisabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.inputRedesign": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.ppUnitSold": {
    defaultValue: "noVariation",
    /** Variations:
     * withUnitSold
     * withoutUnitSold */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppPriceMatrix": {
    defaultValue: "noVariation",
    /** Variations:
     * withPriceMatrix
     * withoutPriceMatrix */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.plpDuplicatedAlgoliaCalls": {
    defaultValue: "noVariation",
    /** Variations:
     * withDuplicatedCalls
     * withoutDuplicatedCalls */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
      /* PLP */
    ],
    provider: "cloudbees"
  },
  "experiment.algoliaCardLinks": {
    defaultValue: "noVariation",
    /** Variations:
     * withDefaultLinks
     * withVariantLinks */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  // Eligibility is card-type driven (parent-level cards), so assigned on all
  // pages rather than scoped to specific routes.
  "experiment.soldCountBadge": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * withoutBadge
     * withBadge */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.newOfferV3": {
    defaultValue: "noVariation",
    /** Variations:
     * without
     * withNewOfferA
     * withNewOfferB */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.ppPriceOpportunity": {
    defaultValue: "noVariation",
    /** Variations:
     * withPriceOpportunity
     * withoutPriceOpportunity */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.postalCodePromise": {
    defaultValue: "noVariation",
    /** Variations:
     * postalCodeEnabled
     * postalCodeDisabled
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.deliveryPromiseDisplay": {
    defaultValue: "noVariation",
    /** Variations:
     * deliveryPromiseDateRange
     * deliveryPromiseDaysCount */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.plpWideContainer": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation
     * withWideContainer
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
      /* PLP page */
    ],
    provider: "cloudbees"
  },
  "experiment.backMarketPromise": {
    defaultValue: "noVariation",
    /** Variations:
     * withBackMarketPromise
     * withoutBackMarketPromise */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.refurbProcess": {
    defaultValue: "noVariation",
    /** Variations:
     * withRefurbProcess
     * withoutRefurbProcess */
    urlPatterns: [
      "^/(en|es)-us/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/wiki/spaces/IRS/pages/6016303277/PRD+Annual+recurring+subscriptions
  "experiment.annualRecurring": {
    defaultValue: "noVariation",
    /** Variations:
     * withAnnualRecurring
     * withoutAnnualRecurring */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.insurancePricingSmartphone": {
    defaultValue: "noVariation",
    /** Variations:
     * withInsurancePricingSmartphone
     * withoutInsurancePricingSmartphone */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.usNewBattery": {
    defaultValue: "noVariation",
    /** Variations:
     * withBatteryPicker
     * withoutBatteryPicker */
    urlPatterns: [
      "^/[a-z]{2}-us/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.ppJapanHistoricalPrice": {
    defaultValue: "noVariation",
    /** Variations:
     * withHistoricalPrice
     * withoutHistoricalPrice */
    urlPatterns: [
      "^/ja-jp/p/.*"
      /* JP Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.shoppingAssistantWeb": {
    defaultValue: "noVariation",
    /** Variations:
     * withAssistant
     * QA gate for the web shopping assistant — targeted to an internal
     * audience rather than rolled out by percentage. */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.assistedSearch": {
    defaultValue: "noVariation",
    /** Variations:
     * withAssistedSearch
     * Pressing Enter in the header search bar both navigates to the search
     * results page and seeds a conversation in the assistant web sidebar.
     * Requires the shopping assistant to be enabled. */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  // AI shopping-assistant suggestion pills under the PDP gallery.
  // Requires the shopping assistant to be enabled.
  "experiment.shoppingAssistantPdpPills": {
    defaultValue: "noVariation",
    /** Variations:
     * withPdpPills
     * withoutPdpPills */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.swapItaly": {
    defaultValue: "noVariation",
    /** Variations:
     * with
     * without */
    urlPatterns: [
      "^/it-it/.*"
      /* All IT pages */
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/wiki/spaces/IRS/pages/6349263236/PRD+Monthly+evergreen+subscriptions+in+the+US?xpis=eyJicmlkZ2UiOiJxdWlja0ZpbmQiLCJpZCI6IjE3ODY1Mjg5MjgzMjciLCJzb3VyY2UiOiJjb25mbHVlbmNlIn0%3D
  "experiment.monthlyEvergreen": {
    defaultValue: "noVariation",
    /** Variations:
     * withMonthlyEvergreen
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.duolingoPartnership": {
    defaultValue: "noVariation",
    /** Variations:
     * withDuolino
     * withoutDuolingo */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*",
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
    ],
    provider: "cloudbees"
  },
  "experiment.desktopNavStyling": {
    defaultValue: "noVariation",
    /** Variations:
     * compact
     * noVariation */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
    ],
    provider: "cloudbees"
  },
  "experiment.jpRefurbishmentInfographic": {
    defaultValue: "noVariation",
    /** Variations:
     * withJpRefurbishmentInfographic
     * withoutJpRefurbishmentInfographic */
    urlPatterns: [
      "^/ja-jp/p/.*"
      /* JP Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.lpoLayout": {
    defaultValue: "noVariation",
    /** Variations:
     * control
     * v1 */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  /**
   * SR-5954 — Live Shopping video + shoppable overlay pilot. Split into one
   * flag per page-type bucket (rather than one flag covering all pages) so
   * CloudBees can independently target/roll out each bucket for a given
   * user — e.g. ramp PDP to 50% while keeping Home at 0%. `urlPatterns` are
   * intentionally broad (not iPad-specific) for the worker's cache hit
   * ratio — the actual "is this page iPad-related" check is client-side,
   * see useIsLiveShoppingEnabled.ts.
   */
  "experiment.liveShoppingOverlayHome": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/en-ie/?$"
      /* Ireland home page */
    ],
    provider: "cloudbees"
  },
  "experiment.liveShoppingOverlayPlpSearch": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/en-ie/l/.*",
      "^/en-ie/search.*"
    ],
    provider: "cloudbees"
  },
  "experiment.liveShoppingOverlayPdp": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/en-ie/p/.*"
      /* Ireland product pages */
    ],
    provider: "cloudbees"
  },
  "experiment.bmProHeaderFRAug26": {
    defaultValue: "noVariation",
    /** Variations:
     * withBmProHeaderVariant */
    urlPatterns: [
      "^/fr-fr.*"
      /* All pages — FR market only */
    ],
    provider: "cloudbees"
  },
  "experiment.bmProHeaderUSSept26": {
    defaultValue: "noVariation",
    /** Variations:
     * withBmProHeaderVariant
     * withoutBmProHeaderVariant */
    urlPatterns: [
      "^/(en|es)-us.*"
      /* All pages — US market only */
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/browse/SR-5939
  "experiment.macbookPLPFinder": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
      /* PLP page */
    ],
    provider: "cloudbees"
  },
  "experiment.realtimeCCM": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/bo-staff/customer-care-manager/.*"
      /* CCM pages */
    ],
    provider: "cloudbees"
  },
  "experiment.plpPaymentAdvertising": {
    defaultValue: "noVariation",
    /** Variations:
     * withAdvertising
     * withoutAdvertising */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.signupBm4bCheckboxDisplayOct": {
    defaultValue: "noVariation",
    /** Variations:
     * withoutBm4bCheckbox
     * withBm4bCheckbox */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/email/signup.*",
      "^/[a-z]{2}-[a-z]{2}/social/validation.*"
    ],
    provider: "cloudbees"
  },
  "experiment.ppFreeShippingBanner": {
    defaultValue: "noVariation",
    /** Variations:
     * withBanner
     * withoutBanner */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.photosInReview": {
    defaultValue: "noVariation",
    /** Variations:
     * withReviewPhotosGuidance */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.reviewPhotosGuidanceDefaultDetails": {
    defaultValue: "noVariation",
    /** Variations:
     * withNewDefaultDetails */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.vertexAiSearch": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation (default: use Algolia)
     * withVertexAiSearch (use Google Vertex AI) */
    urlPatterns: [
      "^/fr-fr.*"
      /* France only */
    ],
    provider: "cloudbees"
  },
  "experiment.vertexAiSearchQa": {
    defaultValue: "noVariation",
    /** Variations:
     * noVariation (default: use Algolia)
     * withVertexAiSearchQa (use Google Vertex AI)
     * QA gate to enable Vertex AI Search for a small share of traffic,
     * independently of the experiment.vertexAiSearch A/B test. Turn it
     * off before starting the A/B test to keep its assignment clean. */
    urlPatterns: [
      "^/fr-fr.*"
      /* France only */
    ],
    provider: "cloudbees"
  },
  "experiment.ppATCNewWording": {
    defaultValue: "noVariation",
    /** Variations:
     * withNewWording
     * withOldWording */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.browsingHistoryPanel": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.ppKeyFeaturesHighlight": {
    defaultValue: "noVariation",
    /** Variations:
     * withKeyFeaturesHighlight
     * withoutKeyFeaturesHighlight */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  "experiment.guestExpressCheckout": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.ppPriceScale": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/p/.*"
      /* Product page */
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/browse/SR-6283
  "experiment.srpReassuranceBanner": {
    defaultValue: "noVariation",
    /** Variations:
     * with
     * without */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/search.*"
      /* Search results page */
    ],
    provider: "cloudbees"
  },
  "experiment.guestAsAuthenticated": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled
     * disabled
     */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}.*"
      /* All pages */
    ],
    provider: "cloudbees"
  },
  "experiment.ksInsuranceInCart": {
    defaultValue: "noVariation",
    /** Variations:
     * withInsuranceInCart
     * withoutInsuranceInCart
     * Kill switch that remove insurances including catch up offers from the cart */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.ksInsuranceCatchUp": {
    defaultValue: "noVariation",
    /** Variations:
     * withInsuranceCatchUp
     * withoutInsuranceCatchUp
     * Kill switch that remove catch up insurances from the cart */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  },
  "experiment.plpQuickFilters": {
    defaultValue: "noVariation",
    /** Variations:
     * visible
     * hidden */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
      /* PLP */
    ],
    provider: "cloudbees"
  },
  "experiment.newInternalLinksServicePlp": {
    defaultValue: "noVariation",
    /** Variations:
     * enabled (new internal-links Go service)
     * disabled (legacy internal-linking service) */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/l/.*"
      /* PLP */
    ],
    provider: "cloudbees"
  },
  // https://backmarket.atlassian.net/browse/CK-7366
  "experiment.checkoutOnePager": {
    defaultValue: "noVariation",
    /** Variations:
     * withOnePager
     * withoutOnePager */
    urlPatterns: [
      "^/[a-z]{2}-[a-z]{2}/f2/.*"
      /* Checkout pages */
    ],
    provider: "cloudbees"
  }
};
export const EXPERIMENT_KEY_PATTERN = /^(experiment|rollout|ops)\.[a-z][a-zA-Z0-9]*$/;
function isValidRegexPattern(pattern) {
  if (typeof pattern !== "string" || pattern.length === 0) return false;
  try {
    return Boolean(new RegExp(pattern));
  } catch {
    return false;
  }
}
export function validateExperimentEntry(key, entry) {
  const errors = [];
  if (!EXPERIMENT_KEY_PATTERN.test(key)) {
    errors.push({ rule: "key", key });
  }
  if (entry.defaultValue !== "noVariation") {
    errors.push({ rule: "defaultValue", key });
  }
  if (!Array.isArray(entry.urlPatterns) || entry.urlPatterns.length === 0 || !entry.urlPatterns.every((pattern) => isValidRegexPattern(pattern))) {
    errors.push({ rule: "urlPatterns", key });
  }
  if (entry.provider !== "cloudbees" && entry.provider !== "amplitude") {
    errors.push({ rule: "provider", key });
  }
  return errors;
}
export function getExperimentProvider(key) {
  return config[key]?.provider;
}
const configEntries = Object.entries(config);
export const cloudbeesExperimentKeys = configEntries.filter(([, entry]) => entry.provider === "cloudbees").map(([key]) => key);
export const amplitudeExperimentKeys = configEntries.filter(([, entry]) => entry.provider === "amplitude").map(([key]) => key);
